import InputController from '@/components/inputs/InputController';
import Select from '@/components/inputs/Select';
import useLanguage from '@/utils/hooks/useLanguage';
import { Tab } from '@headlessui/react';

export const timezoneOptions = [
    { label: 'UTC Timezone', value: 'UTC' },
    { label: 'Local Timezone', value: 'local' }
];

const GeneralTab = () => {
    const lang = useLanguage();
    return (
        <Tab.Panel className="p-2 py-3 sm:p-4 h-auto lg:h-[400px]">
            <div className="space-y-4">
                <div className="space-y-3 sm:space-y-2">
                    <InputController name="general.timezone" label={lang.settings.timezoneSettings} required>
                        <Select options={timezoneOptions} />
                    </InputController>
                    <div className="space-y-3 sm:space-y-1">
                        {lang.settings.timezoneSettingsDescription.split('\n').map((line, index) => (
                            <div key={index} className="text-xs text-brand-neutral-400">
                                {line}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Tab.Panel>
    );
};

export default GeneralTab;
